// extracted by mini-css-extract-plugin
export default {"container":"LocationDetails_container__A1BQG","containerLocation":"LocationDetails_containerLocation__-hIxU"};